import EsignaturesGated from './EsignaturesGated';

export default EsignaturesGated;
